import { useNavigate } from 'react-router-dom';
import { hideBackButton, onBackButtonClick, showBackButton } from '@telegram-apps/sdk-react';
import { type PropsWithChildren, useEffect } from 'react';

export function Page({ children, back = true, onBack }: PropsWithChildren<{
  /**
   * True if it is allowed to go back from this page.
   */
  back?: boolean;
  /**
   * Custom back handler. If not provided, will navigate back in history.
   */
  onBack?: () => void;
}>) {
  const navigate = useNavigate();

  useEffect(() => {
    if (back) {
      showBackButton();
      return onBackButtonClick(() => {
        if (onBack) {
          onBack();
        } else {
          void navigate(-1);
        }
      });
    }
    hideBackButton();
  }, [back, onBack]);

  return <>{children}</>;
}